import { createSlice } from "@reduxjs/toolkit";

// Helper function to check token expiration
function isTokenValid(token) {
  if (!token || !token.access_token) {
    return false;
  }

  // Convert to milliseconds for JavaScript Date
  const expiryDate = new Date(token.access_token_expiry * 1000);

  // Use UTC for current time to match token's UTC-based expiry
  const now = new Date();
  const nowUTC = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds()
    )
  );

  // return nowUTC < expiryDate; // Token is valid if current UTC time is before expiry
  return true;
}

// Load initial state from localStorage
const savedAuthData = JSON.parse(localStorage.getItem("authData"));

const initialState = {
  isLoggedIn: isTokenValid(savedAuthData), // True if token is valid
  token: savedAuthData || null, // Auth data or null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authAction(state, action) {
      switch (action.payload.type) {
        case "LOGIN_SUCCESS":
          const authData = action.payload.data;

          // Save token to localStorage
          localStorage.setItem("authData", JSON.stringify(authData));

          return {
            ...state,
            isLoggedIn: isTokenValid(authData), // Check token validity
            token: authData,
          };

        case "LOGOUT":
          // Clear localStorage and reset state
          localStorage.clear();
          return {
            ...state,
            isLoggedIn: false,
            token: null,
          };

        default:
          return state;
      }
    },
  },
});

export const { authAction } = authSlice.actions;

export default authSlice.reducer;
